<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('detailOrdreTravailAffichage.informations.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.listeAffichage')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ ordreTravail.tourneeAffichage }}</p>
            </b-field>
          </div>
          <div class="column" :class="'is-3'">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.afficheur')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ ordreTravail.afficheur }}</p>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.dateDepart')"
                     custom-class="has-text-default is-italic
                     is-marginless has-text-weight-light mgr-25px">
              <p class="has-text-weight-bold">{{ ordreTravail.dateDepart | formatDate}}</p>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.etat')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ $t(getLibelleEtat) }}</p>
            </b-field>
          </div>
          <div class="column is-2" v-if="societeActive.agences.length > 1">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.agence')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ getLibelleAgence }}</p>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field :label="$t('detailOrdreTravailAffichage.informations.commentaires')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="is-prewrap has-text-weight-bold">{{ ordreTravail.commentaire }}</p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { LISTE_ETAT_ORDRE_TRAVAIL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
    }),
    getLibelleAgence() {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === this.ordreTravail.agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
    getLibelleEtat() {
      return LISTE_ETAT_ORDRE_TRAVAIL.find((etat) => {
        return etat.code === this.ordreTravail.etat;
      }).libelle;
    },
  },
};
</script>

<style scoped>

</style>
